import {eviteVendors} from '~/common/vendors/vendors';
import {Typography} from '~library/atoms/Typography';

import './VendorImages.sass';

const findIcon = (vendorName: string) =>
  eviteVendors.find((vendor) => vendor.name.toLowerCase() === vendorName.toLowerCase());

const amazonIcon = findIcon('amazon');
const targetIcon = findIcon('target');
const walmartIcon = findIcon('walmart');

export const VendorImages = () => {
  return (
    <div className="event-gifting__vendor-images">
      {amazonIcon && (
        <img
          src={amazonIcon.icon_url}
          alt={amazonIcon.name}
          className="event-gifting__vendor-images__amazon"
        />
      )}
      {targetIcon && (
        <img
          src={targetIcon.icon_url_alt}
          alt={targetIcon.name}
          className="event-gifting__vendor-images__target"
        />
      )}
      {walmartIcon && (
        <img
          src={walmartIcon.icon_url}
          alt={walmartIcon.name}
          className="event-gifting__vendor-images__walmart"
        />
      )}
      <Typography variant="paragraph4" color="coin" semibold>
        & more
      </Typography>
    </div>
  );
};
